// 13 unique archetype mappings — one per association
// These are the DEFAULT mappings. If the association has an `archetype` field in DB, that takes priority.
export const ARCHETYPE_MAP = {
  kom:          'archive',      // 1. The Living Archive
  momo:         'amphitheater', // 2. The Digital Amphitheater
  ngoketunjia:  'hearth',       // 3. The Tribal Hearth
  fako:         'observatory',  // 4. The Cosmic Observatory
  meca:         'rebel',        // 5. The Rebel Canvas
  bafut:        'kinetic',      // 6. The Kinetic Motion
  bonbani:      'folklore',     // 7. The Enchanted Folklore
  macuda:       'sovereign',    // 8. The Sovereign Hall
  kmf:          'bazaar',       // 9. The Global Bazaar
  seamoca:      'sanctuary',    // 10. The Pure Sanctuary
  lecda:        'salon',        // 11. The Literary Salon
  menfa:        'stage',        // 12. The Satirical Stage
  oroko:        'laboratory',   // 13. The Citizen Laboratory
};

// Returns archetype: DB field takes priority over hardcoded map
export const getArchetype = (slug, dbArchetype) => {
  if (dbArchetype) return dbArchetype;
  return ARCHETYPE_MAP[slug] || 'hearth';
};
